function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m244.300781 456c-4 0-8 0-12.800781 0l.800781-16h11.199219c117.601562 0 212.800781-95.199219 212.800781-212s-95.199219-212-212-212-212 95.199219-212 212c0 6.398438 0 12.800781.800781 19.199219l-16 1.601562c-.800781-7.199219-.800781-13.601562-.800781-20.800781 0-125.601562 102.398438-228 228-228 125.597657 0 228 102.398438 228 228s-102.402343 228-228 228zm0 0",
  fill: "#5da364"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m112.300781 104h272v128h-272zm0 0",
  fill: "#5da364"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m272.300781 168c0 13.253906-10.746093 24-24 24-13.253906 0-24-10.746094-24-24s10.746094-24 24-24c13.253907 0 24 10.746094 24 24zm0 0",
  fill: "#edc17c"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#538457"
}, /*#__PURE__*/React.createElement("path", {
  d: "m152.300781 160h-16v-32h32v16h-16zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m168.300781 208h-32v-32h16v16h16zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m360.300781 208h-32v-16h16v-16h16zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m360.300781 160h-16v-16h-16v-16h32zm0 0"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m176.300781 160h24v16h-24zm0 0",
  fill: "#edc17c"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m296.300781 160h24v16h-24zm0 0",
  fill: "#edc17c"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m.300781 272h80v120h-80zm0 0",
  fill: "#4a4a56"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m40.300781 272h16v56h-16zm0 0",
  fill: "#676b7f"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m40.300781 344h16v24h-16zm0 0",
  fill: "#676b7f"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m257.898438 485.601562-36.796876-36.800781 37.597657-38.402343 11.199219 12-26.398438 26.402343 26.398438 25.597657zm0 0",
  fill: "#5da364"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m356.300781 307.199219-96.800781 28c-2.398438.800781-4.800781.800781-7.199219.800781l-92-16h56c13.597657 0 24-10.398438 24-24s-10.402343-24-24-24h-100c-2.402343 0-5.601562.800781-8 2.398438l-28 16v78.402343l90.398438 37.597657c3.199219 1.601562 7.199219 1.601562 11.199219.800781l187.203124-58.398438c11.199219-3.199219 17.597657-16 14.398438-27.199219-4-12-15.199219-18.402343-27.199219-14.402343zm0 0",
  fill: "#efccbf"
});

var SvgRefund = function SvgRefund(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "485pt",
    viewBox: "-6 0 485 485.6",
    width: "485pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefund, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refund.0b71c606.svg";
export { ForwardRef as ReactComponent };